/**
 * Footer iletişim sütunu — dinamik satırlar (başlık + içerik + isteğe bağlı bağlantı).
 */

/**
 * @param {unknown} rows
 * @param {Record<string, unknown>} [legacy] — eski address / email / phone / phoneTel için
 * @returns {{ title: string, body: string, href: string }[]}
 */
export function normalizeFooterContactRows(rows, legacy) {
  let list = (Array.isArray(rows) ? rows : [])
    .map((r) => ({
      title: String(r?.title ?? '').trim(),
      body: String(r?.body ?? '').trim(),
      href: String(r?.href ?? '').trim(),
    }))
    .filter((r) => r.title || r.body)

  if (list.length > 0) return list

  const leg = legacy && typeof legacy === 'object' ? legacy : {}
  const addr = String(leg.address ?? '').trim()
  const email = String(leg.email ?? '').trim()
  const phone = String(leg.phone ?? '').trim()
  const phoneTel = String(leg.phoneTel ?? '').trim()

  if (addr) list.push({ title: 'Adres', body: addr, href: '' })
  if (email) {
    const mail = email.replace(/^mailto:/i, '')
    list.push({ title: 'E-posta', body: email, href: `mailto:${mail}` })
  }
  if (phone) {
    const pt = phoneTel.replace(/\s/g, '')
    const href = pt ? `tel:${pt.replace(/^\+/, '')}` : ''
    list.push({ title: 'Telefon', body: phone, href })
  }
  return list
}

/**
 * @param {string} href
 */
export function resolveFooterContactHref(href) {
  const h = String(href ?? '').trim()
  if (!h) return ''
  if (/^(mailto:|tel:|https?:\/\/)/i.test(h)) return h
  if (h.startsWith('/')) return h
  if (h.includes('@')) return `mailto:${h.replace(/^mailto:/i, '')}`
  const digits = h.replace(/\D/g, '')
  if (digits.length >= 10) return `tel:${digits}`
  return h
}
